import { isNull } from 'lodash';
import { snapshot } from 'valtio';
import { logger } from 'logging-utils';
import {
  getAllSelectableTicketFields,
  setDefaultJiraTicketFieldsValues,
} from '../../../jira/api/jira-api';
import { setShowCreateJiraTicketDialog } from '../../active-issues/store-actions/issue-store-actions';
import IssuesStore from '../../active-issues/stores/issues-store';

export const openCreateJiraTicketDialog = async () => {
  const { selectedIssue, isActiveJiraConnection } = snapshot(IssuesStore);
  setShowCreateJiraTicketDialog(true);
  if (!isNull(selectedIssue) && isActiveJiraConnection) {
    try {
      await getAllSelectableTicketFields({
        appId: selectedIssue.app.id,
        category: selectedIssue.category.name,
        issueOwner: selectedIssue.owners[0],
      });
      setDefaultJiraTicketFieldsValues(selectedIssue);
    } catch (e) {
      logger.error(e);
      setShowCreateJiraTicketDialog(false);
    }
  }
};
